import { supabase } from './supabase'

export type Role = 'tutor' | 'intake' | 'admin' | 'super_admin'

export const ALL_ROLES: Role[] = ['tutor', 'intake', 'admin', 'super_admin']

export const ROLE_LABELS: Record<Role, string> = {
  tutor: 'Tutor',
  intake: 'Intake',
  admin: 'Admin',
  super_admin: 'Super admin',
}

export const ROLE_DESCRIPTIONS: Record<Role, string> = {
  tutor: 'Own students, their sessions and balances. No boards.',
  intake: 'Client boards and top-ups only. Cannot approve sessions or change rates.',
  admin: 'Everything except settings and roles.',
  super_admin: 'Everything, including settings and changing roles.',
}

export function roleLabel(role: string | null | undefined): string {
  return ROLE_LABELS[role as Role] ?? 'Unknown'
}

export function hasAdminRights(role: string | null | undefined): boolean {
  return role === 'admin' || role === 'super_admin'
}

export function isSuperAdmin(role: string | null | undefined): boolean {
  return role === 'super_admin'
}

export function canUseBoards(role: string | null | undefined): boolean {
  return role === 'intake' || hasAdminRights(role)
}

export function canUseTutoringPages(role: string | null | undefined): boolean {
  return role === 'tutor' || hasAdminRights(role)
}

export function invitableRoles(role: string | null | undefined): Role[] {
  if (isSuperAdmin(role)) return ALL_ROLES
  if (hasAdminRights(role)) return ['tutor']
  return []
}

export async function fetchMyTutorIds(): Promise<string[]> {
  const { data, error } = await supabase.rpc('my_tutor_ids')
  if (error) throw error
  return ((data ?? []) as any[]).map(r => (typeof r === 'string' ? r : r.my_tutor_ids)).filter(Boolean)
}

export function homePath(role: string | null | undefined): string {
  if (role === 'intake') return '/dashboard/boards'
  return '/dashboard'
}
